export default "__VITE_ASSET__151481b7__"